import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/whatsapp-mode")({
  component: lazyRouteComponent(() => import("./-pages/admin.whatsapp-mode")),
  head: () => ({
    meta: [
      { title: "WhatsApp Mode · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
